<template>
  <div class="vi-filtros-root">
    <!-- ROW 1: grupo de clientes -->
    <div class="vi-filtros-row">
      <div class="vi-filtros-group">
        <label class="vi-filtros-label">Grupo de clientes</label>
        <el-select
          :value="filtroGrupo"
          placeholder="Selecionar grupo"
          class="vi-select"
          @change="$emit('mudar-grupo', $event)"
        >
          <el-option value="0" label="Todos os clientes" />
          <el-option
            v-if="filtros.length === 0"
            value="0"
            label="Sem filtros guardados"
            disabled
          />
          <el-option
            v-for="f in filtros"
            :key="f.id"
            :label="f.nome"
            :value="f.id"
          />
        </el-select>
      </div>

      <div class="vi-filtros-group">
        <label class="vi-filtros-label">Restaurantes</label>
        <el-select
          :value="filtroConsumo.restaurantes"
          multiple
          filterable
          clearable
          collapse-tags
          placeholder="Todos os restaurantes"
          class="vi-select"
          @change="$emit('update:restaurantes', $event)"
        >
          <el-option
            v-for="r in restaurantes"
            :key="r.value"
            :label="r.label"
            :value="r.value"
          />
        </el-select>
      </div>

      <div class="vi-filtros-group">
        <label class="vi-filtros-label">Data início</label>
        <flat-picker
          :value="filtroConsumo.dataInicio"
          placeholder="Data início"
          :config="{
            ...datepickerConfig,
            maxDate: filtroConsumo.dataFim || null,
          }"
          class="form-control vi-date-input"
          @input="$emit('update:dataInicio', $event)"
        />
      </div>

      <div class="vi-filtros-group">
        <label class="vi-filtros-label">Data fim</label>
        <flat-picker
          :value="filtroConsumo.dataFim"
          placeholder="Data fim"
          :config="{
            ...datepickerConfig,
            minDate: filtroConsumo.dataInicio || null,
          }"
          class="form-control vi-date-input"
          @input="$emit('update:dataFim', $event)"
        />
      </div>

      <div class="vi-filtros-actions">
        <button class="vi-btn-apply" @click="$emit('filtrar')">
          <svg
            width="13"
            height="13"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
          >
            <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
          </svg>
          Filtrar
        </button>
        <button
          class="vi-btn-clear"
          @click="$emit('limpar')"
          title="Limpar filtros"
        >
          <svg
            width="13"
            height="13"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
          >
            <path d="M18 6 6 18M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import flatPicker from "vue-flatpickr-component";
  import { Portuguese } from "flatpickr/dist/l10n/pt.js";
  import "flatpickr/dist/flatpickr.css";
  import { Select, Option } from "element-ui";

  export default {
    name: "InsightsFiltros",
    components: {
      flatPicker,
      [Select.name]: Select,
      [Option.name]: Option,
    },
    props: {
      filtroGrupo: { default: null },
      filtros: { type: Array, default: () => [] },
      restaurantes: { type: Array, default: () => [] },
      filtroConsumo: {
        type: Object,
        default: () => ({ restaurantes: [], dataInicio: null, dataFim: null }),
      },
    },
    data() {
      return {
        datepickerConfig: {
          locale: Portuguese,
          altInput: true,
          allowInput: true,
          altFormat: "d/m/Y",
          dateFormat: "Y-m-d",
        },
      };
    },
  };
</script>

<style scoped>
  .vi-filtros-root {
    background: #fff;
    border: 1.5px solid #f0ece8;
    border-radius: 14px;
    padding: 18px 22px;
    margin-bottom: 20px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  }
  .vi-filtros-row {
    display: flex;
    align-items: flex-end;
    gap: 14px;
    flex-wrap: wrap;
  }
  .vi-filtros-group {
    display: flex;
    flex-direction: column;
    gap: 5px;
    flex: 1;
    min-width: 160px;
  }
  .vi-filtros-label {
    font-size: 11px;
    font-weight: 700;
    color: #b0a8a0;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    margin: 0;
  }
  .vi-select {
    width: 100%;
  }
  .vi-select .el-input__inner {
    border: 1.5px solid #e8e4e0 !important;
    border-radius: 9px !important;
    font-size: 13px !important;
    height: 36px !important;
    line-height: 36px !important;
    font-family: inherit !important;
  }
  .vi-date-input {
    border: 1.5px solid #e8e4e0 !important;
    border-radius: 9px !important;
    font-size: 13px !important;
    height: 36px !important;
    padding: 0 10px !important;
  }
  .vi-date-input:focus {
    border-color: #ff825d !important;
    box-shadow: 0 0 0 3px rgba(255, 130, 93, 0.12) !important;
  }
  .vi-filtros-actions {
    display: flex;
    gap: 8px;
    align-items: flex-end;
    padding-bottom: 1px;
  }
  .vi-btn-apply {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 8px 16px;
    background: #ff825d;
    color: #fff;
    border: none;
    border-radius: 9px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.15s;
    font-family: inherit;
    white-space: nowrap;
  }
  .vi-btn-apply:hover {
    background: #e86b45;
  }
  .vi-btn-clear {
    width: 36px;
    height: 36px;
    border-radius: 9px;
    border: 1.5px solid #e8e4e0;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #b0a8a0;
    cursor: pointer;
    transition: all 0.12s;
    flex-shrink: 0;
  }
  .vi-btn-clear:hover {
    border-color: #e05a3a;
    color: #e05a3a;
  }
  @media (max-width: 768px) {
    .vi-filtros-row {
      flex-direction: column;
    }
    .vi-filtros-group {
      min-width: 100%;
    }
    .vi-filtros-actions {
      width: 100%;
    }
    .vi-btn-apply {
      flex: 1;
      justify-content: center;
    }
  }
</style>
